
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMajorSpecialPurpose as ObiSimplifiedBeaconMajorSpecialPurposeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-major-special-purpose.js';
 
 
 

 
 export const ObiSimplifiedBeaconMajorSpecialPurpose = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-major-special-purpose',
   elementClass: ObiSimplifiedBeaconMajorSpecialPurposeElement,
   events: {
     
   }
  });
 
 